// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.General_other__14BYP {\n  margin-top: 36px; }\n", ""]);
// Exports
exports.locals = {
	"other": "General_other__14BYP"
};
module.exports = exports;
